import React from 'react';

import { Select, Spin, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import SearchCpf from './SearchCpf';

import useUserSearch from '../../../hooks/useUserSearch';
import { COLORS } from '../../../utils/theme/colors';
import { QuestionIcon } from '../../atoms/icons/QuestionIcon';

const { Option } = Select;

const FormLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
`;

const FormLabelWrapper = styled.div`
  display: flex;
  .search_cpf_button {
    height: 30px;
    margin: 0 0 5px 10px;
  }

  .search_cpf_input {
    margin-left: 10px;
    width: 280px;
  }
`;

const PrivateStationAccessTransfer = ({ chargeBoxPk, usersPrivateStation, setOwnerUsers, setAccessUsers }) => {
  const routes = useSelector((state) => state.user.routes);
  const { options: ownerOptions, isLoading: ownerLoading, onSearch: onOwnerSearch } = useUserSearch(chargeBoxPk, usersPrivateStation);
  const { options: accessOptions, isLoading: accessLoading, onSearch: onAccessSearch } = useUserSearch(chargeBoxPk, usersPrivateStation);

  const ensureUserInList = (user_pk, availableOptions) => {
    if (!usersPrivateStation.find((u) => u.user_pk === user_pk)) {
      const found = availableOptions.find((u) => u.user_pk === user_pk);
      if (found) usersPrivateStation.push(found);
    }
  };

  const onChangeSelectOwners = (values) => {
    values.forEach((pk) => ensureUserInList(pk, ownerOptions));

    usersPrivateStation.map((x) => (x.owner = false));

    values.map((user_pk) => {
      let foundIndex = usersPrivateStation.map((x) => x.user_pk).indexOf(user_pk);
      let new_obj = { ...usersPrivateStation[foundIndex], owner: true };

      usersPrivateStation[foundIndex] = new_obj;
    });

    setOwnerUsers(values);
  };

  const onChangeSelectAccessUsers = (values) => {
    values.forEach((pk) => ensureUserInList(pk, accessOptions));

    usersPrivateStation.map((x) => (x.bind_status = 'NOT_REQUESTED'));

    values.map((user_pk) => {
      let foundIndex = usersPrivateStation.map((x) => x.user_pk).indexOf(user_pk);
      let new_obj = { ...usersPrivateStation[foundIndex], bind_status: 'ACCEPTED' };

      usersPrivateStation[foundIndex] = new_obj;
    });

    setAccessUsers(values);
  };

  const handleSetOwnerNewValue = (userFound) => {
    let userPkFound = userFound?.user_pk;
    let foundIndex = usersPrivateStation.map((x) => x.user_pk).indexOf(userPkFound);
    if (foundIndex === -1) {
      usersPrivateStation.push(userFound);
      foundIndex = usersPrivateStation.length - 1;
    }
    let new_obj = { ...usersPrivateStation[foundIndex], owner: true };

    usersPrivateStation[foundIndex] = new_obj;

    setOwnerUsers(usersPrivateStation?.filter((u) => u.owner == true).map((u) => u.user_pk));
  };

  const handleSetNewValueAccess = (userFound) => {
    let userPkFound = userFound?.user_pk;
    let foundIndex = usersPrivateStation.map((x) => x.user_pk).indexOf(userPkFound);
    if (foundIndex === -1) {
      usersPrivateStation.push(userFound);
      foundIndex = usersPrivateStation.length - 1;
    }
    let new_obj = { ...usersPrivateStation[foundIndex], bind_status: 'ACCEPTED' };

    usersPrivateStation[foundIndex] = new_obj;

    setAccessUsers(usersPrivateStation?.filter((u) => u.bind_status == 'ACCEPTED').map((u) => u.user_pk));
  };

  return (
    <>
      <FormLabelWrapper>
        <FormLabel>{T('Owners')}:</FormLabel>
        <Tooltip title={T('Owners can manage who can access the private station.')}>
          <span>
            <QuestionIcon size={15} color={COLORS.primary} />
          </span>
        </Tooltip>

        {routes && routes.find(({ path }) => path === '/users_data/tenant_parent/cpf') ? (
          <SearchCpf chargeBoxPk={chargeBoxPk} onSetNewValue={handleSetOwnerNewValue} />
        ) : null}
      </FormLabelWrapper>

      <Select
        mode='multiple'
        style={{ width: '840px', marginBottom: '10px' }}
        placeholder={T('Select users')}
        onChange={onChangeSelectOwners}
        value={usersPrivateStation.filter((user) => user.owner == true).map((user) => user.user_pk)}
        showSearch
        filterOption={false}
        onSearch={onOwnerSearch}
        onDropdownVisibleChange={(open) => { if (!open) onOwnerSearch(''); }}
        loading={ownerLoading}
        notFoundContent={ownerLoading ? <Spin size='small' /> : null}
        size='large'
      >
        {ownerOptions.map((value, index) => (
          <Option key={index} value={value.user_pk}>
            {value.email} - {value.user_name} [{value.tenant_name}]
          </Option>
        ))}
      </Select>

      <FormLabelWrapper>
        <FormLabel>{T('Users with access')}:</FormLabel>
        <Tooltip title={T('Users who only have access to the private station.')}>
          <span>
            <QuestionIcon size={15} color={COLORS.primary} />
          </span>
        </Tooltip>

        {routes && routes.find(({ path }) => path === '/users_data/tenant_parent/cpf') ? (
          <SearchCpf chargeBoxPk={chargeBoxPk} onSetNewValue={handleSetNewValueAccess} />
        ) : null}
      </FormLabelWrapper>

      <Select
        mode='multiple'
        style={{ width: '840px' }}
        placeholder={T('Select users')}
        onChange={onChangeSelectAccessUsers}
        value={usersPrivateStation.filter((user) => user.bind_status == 'ACCEPTED').map((user) => user.user_pk)}
        showSearch
        filterOption={false}
        onSearch={onAccessSearch}
        onDropdownVisibleChange={(open) => { if (!open) onAccessSearch(''); }}
        loading={accessLoading}
        notFoundContent={accessLoading ? <Spin size='small' /> : null}
        size='large'
      >
        {accessOptions.map((value, index) => (
          <Option key={index} value={value.user_pk}>
            {value.email} - {value.user_name} [{value.tenant_name}]
          </Option>
        ))}
      </Select>
    </>
  );
};

export default PrivateStationAccessTransfer;
